module.exports.parse = require('./lib/parse');
module.exports.METERS_PER_FOOT = module.exports.parse.METERS_PER_FOOT;
module.exports.format = require('./lib/format');
// console.log(module.exports);
